export const PERMISSIONS_GENERAL = {
  ADD: 'add',
  ADD_SERVING: 'add_serving',
  BASIC_INFO: 'basic_info',
  COPY: 'copy',
  DELETE: 'delete',
  DOWNLOAD: 'download',
  EDIT: 'edit',
  EDIT_PROFILE: 'edit_profile',
  EDIT_EXCHANGES: 'edit_exchanges',
  LIST: 'list',
  SET_STATUS: 'set_status',
  SHARE: 'share',
  USE: 'use',
  USE_AS_EXCHANGE: 'use_as_exchange',
  VIEW: 'view',
  INVITE_PARTICIPANT: 'invite_participant',
  INVITE_TEAM_MEMBER: 'invite_team_member',
  SEND_TOKEN: 'send_token',
  ADD_PROGRAM: 'add_program',
  VIEW_PROGRAM: 'view_program',
  EDIT_PROGRAM: 'edit_program',
  DELETE_PROGRAM: 'delete_program',
  SECURITY: 'security',
  VIEW_PROFILE: 'view_profile',
  VIEW_ROLES: 'view_roles',
  EDIT_ROLES: 'edit_roles',
  VIEW_BIOGRAPHY: 'view_biography',
  EDIT_BIOGRAPHY: 'edit_biography',
  VIEW_EVOLUTION: 'view_evolution',
  EDIT_EVOLUTION: 'edit_evolution',
  VIEW_EVOLUTION_SETTINGS: 'view_evolution_settings',
  EDIT_EVOLUTION_SETTINGS: 'edit_evolution_settings',
  VIEW_SCHEDULES: 'view_schedules',
  VIEW_PROGRAMS: 'view_programs',
  EDIT_PROGRAMS: 'edit_programs',
  VIEW_SUBSCRIPTION: 'view_subscription',
  EDIT_SUBSCRIPTION: 'edit_subscription',
  BUY_SUBSCRIPTION: 'buy_subscription',
  PROCESS_INVOICES: 'process_invoices',
  ACCEPT: 'accept',
  MARK_AS_DRAFT: 'mark_as_draft',
  MARK_AS_READY: 'mark_as_ready',
  ACTIVATE: 'activate',
  PUT_ON_HOLD: 'put_on_hold',
  REACTIVATE: 'reactivate',
  CANCEL: 'cancel',
  EDIT_SPECIAL: 'edit_special',
};

export const PERMISSIONS_SUBSCRIBED_PLAN = {
  ACTIVITY_SOURCES: 'activity_sources',
  CALENDAR_SYNCHRONISATION: 'calendar_synchronisation',
  COLLABORATION: 'collaboration',
  CUSTOM_ACTIVITY_ITEMS: 'custom_activity_items',
  CUSTOM_FOOD_ITEMS: 'custom_food_items',
  FOOD_SOURCES: 'food_sources',
  LANDING_PAGE_CUSTOMISATION: 'landing_page_customisation',
  NUTRITION_LABEL_CUSTOMISATION: 'nutrition_label_customisation',
  NUTRITION_LABEL_PRINTING: 'nutrition_label_printing',
  PARTICIPANT_EVOLUTION: 'participant_evolution',
  PARTICIPANTS: 'participants',
  PREMIUM_SOURCE_BRANDED: 'premium_source_branded',
  PROGRAM_DURATION: 'program_duration',
  STEP_BY_STEP_INSTRUCTIONS: 'step_by_step_instructions',
  STORAGE_SPACE: 'storage_space',
  TEAM_MEMBERS: 'team_members',
  FOOD_ALLERGENS: 'food_allergens',
  OPTION: {
    PARTICIPANT_EVOLUTION_BASIC: 'participant_evolution_basic',
    PARTICIPANT_EVOLUTION_FOLDS: 'participant_evolution_folds',
    PARTICIPANT_EVOLUTION_INTEGRATION: 'participant_evolution_integration',
  },
};



// WEBPACK FOOTER //
// ./src/constants/permissions.js